import styled from "@emotion/styled";

export const Img = styled.img((props) => ({
    maxWidth: "49%",
    margin: "5px auto",
}));
